export const colors = {
  sunglow: "#ffd147ff",
  oxfordBlue: "#061a40ff",
  sapphire: "#0353a4ff",
  biceBlue: "#006daaff",
  mantis: "#84c76bff",
};

